import script from "./CustomerShowInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerShowInfo.vue?vue&type=script&setup=true&lang=js"

import "./CustomerShowInfo.vue?vue&type=style&index=0&id=8916ec82&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8916ec82"]])

export default __exports__